/*
* Broadcast Theme
*
* Use this file to add custom Javascript to Broadcast.  Keeping your custom
* Javascript in this fill will make it easier to update Broadcast. In order
* to use this file you will need to open layout/theme.liquid and uncomment
* the custom.js script import line near the bottom of the file.
*/


(function() {
  // Add custom code below this line

  // Gift-note-style line item text inputs state their character limit in the
  // block's own label (e.g. "Your message here: (100 char. limit)" or
  // "Message (100 Character Limit)") rather than a real maxlength attribute.
  // Read it back out of the label so this keeps working after a vendor theme
  // update overwrites sections/product.liquid and section-featured-product.liquid
  // (this file is the one place the vendor says is safe to keep customizations in).
  [...document.querySelectorAll('input.properties__input')].forEach(input=>{
    const label = document.querySelector('label[for="' + input.id + '"]');
    const match = label && label.textContent.match(/(\d+)\s*char/i);
    const limit = match ? parseInt(match[1], 10) : null;

    if (limit) {
      input.setAttribute('maxlength', limit);
    }

    input.oninput=()=>{
      let fixedValue = "";
      for (const c of input.value) {if (c.charCodeAt(0) >= 0x20 && c.charCodeAt(0) <0x7F) {fixedValue = fixedValue + c;}}
      if (limit && fixedValue.length > limit) {fixedValue = fixedValue.slice(0, limit);}
      if (input.value!=fixedValue) {input.value = fixedValue;}
    }
  });
  // ^^ Keep your scripts inside this IIFE function call to
  // avoid leaking your variables into the global scope.
})();
